/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCancelFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCancelFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCancelFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCancelFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-14iTd8': alignSelf,'--mt-2-14iTd8': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-14iTd8': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-14iTd8': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-14iTd8': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-14iTd8': opacity,'--w-10-14iTd8': typeof width === 'number' ? `${width}px` : width,'--h-11-14iTd8': typeof height === 'number' ? `${height}px` : height,'--a-7-14iTd8': isAnimated ? animation : "none",'--sd-8-14iTd8': isAnimated ? strokeDashoffset : 0,'--sd-9-14iTd8': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCancelFilled.SvgPath"
  data-view-path={viewPath}
 d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
 style={{'--f-12-14iTd8': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}